// dependencies
import { Map, List } from "immutable";
import { createSelector } from "reselect";
import { getMatchedRouteKeyValue } from "yarrr";

// selectors
import { getUI } from "Selectors/ui";

export const getGraphsList = (state) => getUI(state).getIn(["graphs"], List());

/** Gets the active graph name from the URL */
export const getActiveGraph = (state) => {
	const graphsList = getGraphsList(state);
	const graphURL = getMatchedRouteKeyValue(state, "graphName", null);

	return graphsList.find((item) => item.get("url") === graphURL, null, Map());
};

/** Gets just the name of the active graph */
export const getActiveGraphName = createSelector([getActiveGraph], (activeGraph) => activeGraph.get("name", null));

/** Get data for the active graph */
export const getActiveGraphData = (state) => getUI(state).getIn(["activeGraphData"], Map());
